import React from 'react';
import { AlertCircle, Upload } from 'lucide-react';

import UploadRow from './documents/upload.row.component';

const NEEDS_FILE = ['stalled', 'failed'];

const RESUME_HINT = 'Escolha o arquivo de novo para continuar de onde parou.';

const titleOf = (count) => (count === 1 ? 'Este arquivo não chegou' : 'Estes arquivos não chegaram');

const finishLabelOf = (count) => (count === 1 ? 'Finalizar sem este arquivo' : 'Finalizar sem estes arquivos');

const StalledRow = ({ row, onResend }) => {
    const inputId = `stalled-${row.sessionId}`;
    return (
        <li className='flex items-center gap-3 border-b border-amber-100 py-2.5 last:border-b-0'>
            <AlertCircle aria-hidden='true' className='h-5 w-5 shrink-0 text-amber-600' />
            <div className='min-w-0 flex-1'>
                <p className='truncate text-sm text-gray-900'>{row.fileName}</p>
                <p className={`text-xs ${row.status === 'failed' ? 'text-red-600' : 'text-gray-600'}`}>
                    {row.status === 'failed' ? row.failureMessage : RESUME_HINT}
                </p>
            </div>
            <label
                htmlFor={inputId}
                className='inline-flex cursor-pointer items-center gap-1.5 rounded-md border border-primary px-3 py-1.5 text-xs font-semibold text-primary hover:bg-primaryTint'
            >
                <Upload aria-hidden='true' className='h-3.5 w-3.5' />
                Escolher arquivo
            </label>
            <input
                id={inputId}
                type='file'
                aria-label={`Escolher ${row.fileName} de novo`}
                className='sr-only'
                onChange={(event) => event.target.files[0] && onResend(row.sessionId, event.target.files[0])}
            />
        </li>
    );
};

const StalledUploads = ({ rows, onResend, onFinishWithout }) => {
    if (!rows.length) return null;
    return (
        <section aria-label='Arquivos que não chegaram' className='mb-4 w-full rounded-lg border border-amber-200 bg-amber-50 px-4 py-3'>
            <p className='text-sm font-semibold text-gray-900'>{titleOf(rows.length)}</p>
            <p className='mt-0.5 text-xs text-gray-600'>O envio parou antes de terminar, provavelmente porque a página foi fechada.</p>
            <ul className='mt-2 list-none p-0'>
                {rows.map(row => (NEEDS_FILE.includes(row.status)
                    ? <StalledRow key={row.sessionId} row={row} onResend={onResend} />
                    : <UploadRow key={row.sessionId} doc={{ ...row, name: row.fileName, _localId: row.sessionId }} onRemove={() => undefined} />))}
            </ul>
            <button
                type='button'
                className='mt-2 text-xs font-semibold text-gray-700 underline hover:text-gray-900'
                onClick={onFinishWithout}
            >
                {finishLabelOf(rows.length)}
            </button>
        </section>
    );
};

export default StalledUploads;
